import React from 'react'
import { Container, Content, Header } from './styles'
import { HealthProcedureAccordionCardList } from '~/components/healthProcedures/HealthProcedureAccordionCardList'
import { ListCardHealthProcedure } from '~/components/healthProcedures/ListCardHealthProcedure'
import { Tag } from '~/components/shared'
import { SidePanel } from '~/components/shared/medicalViews'
import { ContainerTags } from '~/components/shared/medicalViews/sidePanel/styles'
import { ConductAndOmics } from '~/components/healthProcedures/ConductAndOmics'
import { useRadiologyHealthProcedures } from '~/context'
import { IFilterTag, IHealthProceduresConduct, IHealthProceduresOmics } from '~/interfaces'
import { message } from '~/services'
import { filterHealthProceduresPer, isConduct, isOmics, timelineFilters } from '~/utils'

export const RadiologySidePanel = (): JSX.Element => {
  const {
    sidePanelEvents,

    openConductCardList,
    setOpenConductCardList,
    openOmicsCardList,
    setOpenOmicsCardList,

    filterTags,
    dateFiltersActive,
    typeFiltersActive,
    removeFilterTag,

    selectMedicalEventForDetailing
  } = useRadiologyHealthProcedures()

  const searchTerms = filterTags?.filter(tag => tag.type === 'searchTerm').map(tag => tag.text)
  const filteredMedicalEvents = timelineFilters(sidePanelEvents)
    .perDate(dateFiltersActive)
    .perType(typeFiltersActive)
    .perMultipleTextTerms(searchTerms).value

  const medicalEventsOfConductPanel = filterHealthProceduresPer(filteredMedicalEvents, isConduct)
  const medicalEventsOfOmicsPanel = filterHealthProceduresPer(filteredMedicalEvents, isOmics)

  const handleSelectDataConduct = (healthProcedure: IHealthProceduresConduct) => {
    selectMedicalEventForDetailing(healthProcedure)
  }

  const handleSelectDataOmics = (healthProcedure: IHealthProceduresOmics) => {
    selectMedicalEventForDetailing(healthProcedure)
  }

  const handleCloseFilterTag = (tag: IFilterTag): void => removeFilterTag(tag)

  return (
    <SidePanel>
      <Container>
        <Header>
          <ContainerTags>
            {filterTags.map((tag, index) => {
              const { id, text, color } = tag
              return <Tag key={`${id}-${index}`} text={text} color={color} onClose={() => handleCloseFilterTag(tag)} />
            })}
          </ContainerTags>
        </Header>
        <Content>
          <ConductAndOmics>
            <HealthProcedureAccordionCardList
              title={message('healthProcedures.conduct')}
              expanded={openConductCardList}
              setExpanded={setOpenConductCardList}
            >
              <ListCardHealthProcedure
                list={medicalEventsOfConductPanel}
                onSelectCard={conduct => handleSelectDataConduct(conduct as IHealthProceduresConduct)}
              />
            </HealthProcedureAccordionCardList>

            <HealthProcedureAccordionCardList
              title={message('healthProcedures.omics')}
              expanded={openOmicsCardList}
              setExpanded={setOpenOmicsCardList}
            >
              <ListCardHealthProcedure
                list={medicalEventsOfOmicsPanel}
                onSelectCard={omics => handleSelectDataOmics(omics as IHealthProceduresOmics)}
              />
            </HealthProcedureAccordionCardList>
          </ConductAndOmics>
        </Content>
      </Container>
    </SidePanel>
  )
}
